<div class="ant-collapse" [class.ant-collapse-borderless]="!dwBordered">
  <ng-content></ng-content>
</div>